import { useState } from 'react'
import { endOfWeek, formatISO, startOfWeek } from 'date-fns'
import PageLoader from '@/compoments/PageLoader'
import { DispatherDashboardQueryParams } from '@/types/dispatcher/query.params.types'
import { useGetDispatcherDashboardQuery } from '@/services/dispatcher/dispather'
import JobStatistics from './parts/JobStatistics'
import Charts from './parts/Charts'

const startDate = formatISO(startOfWeek(new Date()))
const endDate = formatISO(endOfWeek(new Date()))

const DashboardPage = () => {
    const [queryParams, setQueryParams] =
        useState<DispatherDashboardQueryParams>({
            trendStartDate: startDate,
            trendEndDate: endDate,
            typeStartDate: startDate,
            typeEndDate: endDate,
            feedbackStartDate: startDate,
            feedbackEndDate: endDate,
            orderStartDate: startDate,
            orderEndDate: endDate,
        })

    const { data, isLoading, isFetching } =
        useGetDispatcherDashboardQuery(queryParams)

    const pageData = data?.data

    if (isLoading) {
        return <PageLoader />
    }

    return (
        <main className="content">
            <div className="px-container">
                {!data?.data && !isLoading && !data?.success ? (
                    <h4 className="text-center mt-4">{data?.message}</h4>
                ) : (
                    <div className="row gutters-28">
                        <JobStatistics data={pageData?.orderStatistics} />
                        <Charts
                            data={pageData}
                            setQueryParams={setQueryParams}
                        />
                    </div>
                )}
            </div>
        </main>
    )
}

export default DashboardPage
